module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_1326201718713048.09cce524.jpg";